import useWallets from '../customhooks/wallets/useWallets';
import { WalletBalances } from './walletbalances/WalletBalances';
import { useState } from 'react';
import ViewAccounts from '../pages/dashboard/payments/ViewAccounts';
import TopupAccount from '../pages/dashboard/payments/TopupAccount';
import { useLocation, useNavigate } from 'react-router-dom';
import { useUserProfile } from '../customhooks/useUserProfile';
import { hasPermission } from './dashboard/dashboardpage/utils';
import { EyesIcon } from './icons';
import { MoneySendIcon, WalletAddIcon } from './icons';

export const CustomerWalletBalances = () => {
    const navigate = useNavigate();

    const { wallets, isLoading: isLoadingWallets } = useWallets();
    const { permissions } = useUserProfile();
    const [showViewAccounts, setShowViewAccounts] = useState(false);
    const [showTopUp, setShowTopUp] = useState(false);

    const location = useLocation();

    const isPayment =
        ['transactions', 'beneficiaries', 'approvals'].indexOf(
            location.pathname.split('/')[2]
        ) === -1;

    const actions = [
        {
            onHandleClick: () => {
                navigate(
                    isPayment
                        ? '/payments/transactions'
                        : '/payments/make-payment'
                );
            },
            display:
                !location.pathname.includes('logistics') &&
                permissions &&
                hasPermission({
                    userPermissions: permissions,
                    module: 'payments',
                    permissionList: ['write', '*']
                }),
            title: isPayment ? 'Transactions' : 'Make payment',
            icon: <MoneySendIcon />
        },
        {
            onHandleClick: () => {
                setShowTopUp(true);
            },
            display:
                permissions &&
                hasPermission({
                    userPermissions: permissions,
                    module: 'payments',
                    permissionList: ['write', '*']
                }),
            title: 'Add Funds',
            icon: <WalletAddIcon />
        },
        {
            onHandleClick: () => {
                setShowViewAccounts(true);
            },
            display:
                permissions &&
                hasPermission({
                    userPermissions: permissions,
                    module: 'payments',
                    permissionList: ['write', '*', 'read']
                }),
            title: 'View accounts',
            icon: <EyesIcon size={19} color='#475467' />
        }
    ];

    return (
        <>
            <WalletBalances
                wallets={wallets}
                isLoading={isLoadingWallets}
                actions={actions}
            />

            <ViewAccounts
                wallets={wallets}
                closeDrawer={() => setShowViewAccounts(false)}
                showDrawer={showViewAccounts}
            />

            <TopupAccount
                wallets={wallets}
                closeDrawer={() => setShowTopUp(false)}
                showDrawer={showTopUp}
                loadingWallets={isLoadingWallets}
            />
        </>
    );
};
